import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

export const addToCart = (params = {}) => axios.post(`${API_URLS.CART}add`, { ...params });
